// ***********************Add CATEGORIES********************
export const ADD_CATEGORIES_SUCCESS = "ADD_CATEGORIES_SUCCESS";
export const ADD_CATEGORIES_REQUEST = "ADD_CATEGORIES_REQUEST";
export const ADD_CATEGORIES_FAIL = "ADD_CATEGORIES_FAIL";

// ***********************Add CATEGORIES********************
export const GET_CATEGORIES_SUCCESS = "GET_CATEGORIES_SUCCESS";
export const GET_CATEGORIES_REQUEST = "GET_CATEGORIES_REQUEST";
export const GET_CATEGORIES_FAIL = "GET_CATEGORIES_FAIL";
